module.exports = __webpack_public_path__ + "img/Genio Alert.ccb9bca7.svg";